/**
 * Created by Jan Bradac on 15.5.2016.
 */


(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Tooltips;

    (function (Tooltips, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Tooltips, 'HidingFix')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Sometimes tooltips stay on the screen when they should actually hide. The user will most probably try to
         * "get them away" by clicking. This object allows them to do just that.
         *
         * @memberOf Lfl.Tooltips
         */
        Lfl.Tooltips.HidingFix;

        (function (HidingFix, $, undefined) {
            /*
             |===========================================================================================================
             | Object definition
             |===========================================================================================================
             */

            var isActivated = false;

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Activates the fix
             * @memberOf Lfl.Tooltips.HidingFix
             */

            HidingFix.activate = function () {
                if (false === isActivated) {
                    isActivated = true;

                    $('body').click(function () {
                        $(".tooltip").each(function (jQueryStartsWithRetardedIndexAndAlwaysGoddamnConfusingTheHellOutOfMe, theActualTooltip) {
                            if (isActivated) {
                                $(theActualTooltip).hide();
                            }
                        })
                    });
                }
            };

            /**
             * Deactivates the fix
             * @memberOf Lfl.Tooltips.HidingFix
             */
            HidingFix.deactivate = function () {
                isActivated = false;
            };


            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */
        }(Tooltips.HidingFix = Tooltips.HidingFix || {}, jQuery));
    }(Lfl.Tooltips = Lfl.Tooltips || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
